<div class="row ap-my-spacing-5">
    <div class="col-12">
        <app-header-page [title]="'Upcoming'"></app-header-page>
    </div>
    <div class="col-12 ap-mt-spacing-3">
        <app-callsheets-table [actionsPanel]="actionsPanel" [moreOptionsPanel]="moreOptionsPanel" [actionsList]="actionsList" [moreOptionsList]="moreOptionsList"  [callsheets]="(callsheets$ | async)!" [showProjectUrl]="showProjectUrl"
            (onPageChange)="onPageChange($event)" [feature]="feature" [totalPages]="(totalPages$ | async)!" (onAction)="handleActions($event)"></app-callsheets-table>
    </div>
</div>